import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { IonicModule, ModalController } from '@ionic/angular';
import { IKegtron, IKegtronVM } from '../../models/kegtron';
import { Store } from '@ngrx/store';
import * as fromKegtron from 'app/state/kegtron';
import * as fromTap from 'app/state/tap';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-select-kegtron',
  templateUrl: './select-kegtron.component.html',
  styleUrls: ['./select-kegtron.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class SelectKegtronComponent implements OnInit {

  items$!: Observable<IKegtronVM[]>;

  constructor(
    private kegtronStore: Store<fromKegtron.State>,
    private modalController: ModalController,
  ) { }

  ngOnInit() {
    this.items$ = this.kegtronStore.select(fromTap.getKegtronsWithTap);
  }


  selectItem(item: IKegtron) {
    this.modalController.dismiss({
      item
    });
  }


  closeModal() {
    this.modalController.dismiss();
  }



}
